#import "../fragments/tag-count-fragment.graphql"

query GetLeadTagMaps($leadId: ID, $number: Int) {
    lead(id: $leadId, number: $number) {
        id
        tagMaps(first: 1000) {
            edges {
                creator {
                    id
                    name
                }
                createdTime
                node {
                    ...TagCount
                }
            }
        }
        tags {
            id
            name
            color
            creator {
                id
                name
            }
        }
    }
}
